import styled from "styled-components";

export const LoginCard = styled.div`
    margin: auto;
    width: 75vw;
    border: 3px solid aqua;
    padding-bottom: 2.5%;
    font-size: 1.5em;
    text-align-last: center;
    margin-top: 40px;
`;

export const Title = styled.div`
    font-size: 1.5em;
`;

export const SizedLabel = styled.label`
    color: red;
`;

export const H6Link = styled.h6`
    color: blue;
    border-bottom: 1px solid black;
    padding-top: 1%;
`

export const TextField = styled.input``;

export default TextField;
